import { useDispatch, useSelector } from "react-redux"

import HealthActions from "../../../../reducer"

export const useEnrollmentModal = () => {
  const dispatch = useDispatch()
  const vampEnrollmentRequestLoading = useSelector(
    (state) => state.health.vampEnrollmentRequestLoading
  )

  const open = () => {
    dispatch(HealthActions.healthSetProp("showEnrollmentModal", true))
  }

  const close = () => {
    dispatch(HealthActions.healthSetProp("showEnrollmentModal", false))
  }

  const isOpened = useSelector((state) => state.health.showEnrollmentModal)

  const enroll = async (data) => {
    if (vampEnrollmentRequestLoading) return
    return new Promise((resolve, reject) => {
      dispatch(
        HealthActions.createVampEnrollmentRequest({
          ...data,
          onSuccess: (data) => {
            resolve(data)
          },
          onError: (error) => {
            reject(error)
          }
        })
      )
    })
  }

  return {
    open,
    close,
    enroll,
    isOpened,
    loading: vampEnrollmentRequestLoading
  }
}
